import { Hold } from './Hold';
import { Laerer } from './Laerer'; 
export class Tilmelding {
        public id: string;
        public konkurrenceId: string;
        public hold: Hold;
        public inviteredeLaerere: Laerer[];
        public tilmeldteLaerere: Laerer[];
        public opgavepakkeId: string;
        public paaVenteliste: boolean;
        public selvTilmeldt: boolean;
        public brugerNavn: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Tilmelding.ts